class ExtendSectionT3Product extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initProductShowcase());
    // // 滚动驱动
    // this._scrollEffects = [
    //   _safeInit(() => this.initComparison()),
    // ].filter(Boolean);
    // // 尺寸变化驱动
    // this._resizeEffects = [
    //   _safeInit(() => this.initRecordingWorkflow()),
    // ].filter(Boolean);
    // if (!!this._scrollEffects) {
    //   this._scrollEffects.forEach((fn) => fn());
    // }
  }

  onScroll() {
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onResize() {
    super.onResize(); // 执行基类 _resizeFlktyListAll()
    if (!!this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }

  initProductShowcase() {
    const _bindSection = (sectionEl) => {
      if (!sectionEl || sectionEl.dataset.et3psBound === "true") {
        return;
      }

      const wrapper = this._q('[name="et3ps__wrapper"]', sectionEl);

      if (!wrapper) return;

      sectionEl.dataset.et3psBound = "true";

      /* ==================== 公共状态与滚动锁定 begin ==================== */

      let destroyed = false;
      let activeDialog = null;
      let dialogOpener = null;
      let scrollLocked = false;

      const _lockScroll = () => {
        if (scrollLocked) return;

        if (!ExtendSectionT3Product._et3psLockCount) {
          ExtendSectionT3Product._et3psLockCount = 0;
          ExtendSectionT3Product._et3psPreviousOverflow =
            document.documentElement.style.overflow;
        }

        ExtendSectionT3Product._et3psLockCount += 1;
        document.documentElement.style.overflow = "hidden";
        scrollLocked = true;
      };

      const _unlockScroll = () => {
        if (!scrollLocked) return;

        ExtendSectionT3Product._et3psLockCount = Math.max(
          0,
          (ExtendSectionT3Product._et3psLockCount || 0) - 1
        );

        if (ExtendSectionT3Product._et3psLockCount === 0) {
          document.documentElement.style.overflow =
            ExtendSectionT3Product._et3psPreviousOverflow || "";
        }

        scrollLocked = false;
      };

      /* ==================== 公共状态与滚动锁定 end ==================== */

      /* ==================== 产品图片 / 视频切换 begin ==================== */

      const gallery = this._q('[name="et3ps__viewer"]', sectionEl);
      const slides = this._qa('[name="et3ps__slide"]', sectionEl);
      const modes = this._qa('[name="et3ps__mode"]', sectionEl);
      const dots = this._q('[name="et3ps__dots"]', sectionEl);
      const previousButton = this._q('[name="et3ps__prev"]', sectionEl);
      const nextButton = this._q('[name="et3ps__next"]', sectionEl);

      let activeSlides = [];
      let activeIndex = 0;
      let activeMode = "photo";

      const _pauseVideos = () => {
        this._qa("video", sectionEl).forEach((video) => {
          video.pause();
        });
      };

      // 切换当前媒体，并暂停隐藏媒体中的视频。
      const _renderSlide = (index) => {
        if (!activeSlides.length) return;

        activeIndex = (index + activeSlides.length) % activeSlides.length;

        const activeSlide = activeSlides[activeIndex];

        /* Visual background sync begin */
        const visual = this._q(".et3ps__visual", sectionEl);

        if (visual) {
          visual.style.setProperty(
            "--et3ps-visual-background",
            activeSlide.dataset.visualBackground || "#000000"
          );
        }
        /* Visual background sync end */

        // 根据当前媒体同步 Photo / Intro 按钮配色。
        if (gallery) {
          gallery.setAttribute(
            "data-buttons-color",
            activeSlide.dataset.buttonsColor || "dark"
          );
        }

        slides.forEach((slide) => {
          const selected = slide === activeSlide;

          slide.hidden = !selected;
          slide.setAttribute("aria-hidden", selected ? "false" : "true");

          if (!selected) {
            this._qa("video", slide).forEach((video) => {
              video.pause();
            });
          }
        });

        if (dots) {
          this._qa("button", dots).forEach((button, index) => {
            button.setAttribute(
              "aria-current",
              index === activeIndex ? "true" : "false"
            );
          });
        }
      };

      // 切换 Photo / Intro，并重建该模式下的导航圆点。
      const _setMode = (mode) => {
        const matchingSlides = slides.filter((slide) => {
          return slide.dataset.kind === mode;
        });

        if (!matchingSlides.length) return;

        _pauseVideos();

        activeMode = mode;
        activeSlides = matchingSlides;
        activeIndex = 0;

        modes.forEach((button) => {
          button.setAttribute(
            "aria-pressed",
            button.dataset.mode === activeMode ? "true" : "false"
          );
        });

        if (dots) {
          dots.textContent = "";

          activeSlides.forEach((slide, index) => {
            const button = document.createElement("button");
            const caption = this._q(".et3ps__caption", slide);
            const modeButton = modes.filter((item) => {
              return item.dataset.mode === activeMode;
            })[0];

            let label = gallery
              ? gallery.getAttribute("aria-label")
              : activeMode;

            if (modeButton) {
              label = modeButton.textContent.trim();
            }

            if (caption) {
              label = caption.textContent.trim();
            }

            button.type = "button";
            button.className = "et3ps__dot";
            button.setAttribute(
              "aria-label",
              (label || activeMode) + " " + (index + 1)
            );

            button.addEventListener("click", () => {
              _renderSlide(index);
            });

            dots.appendChild(button);
          });

          dots.hidden = activeSlides.length < 2;
        }

        if (previousButton) {
          previousButton.hidden = activeSlides.length < 2;
        }

        if (nextButton) {
          nextButton.hidden = activeSlides.length < 2;
        }

        _renderSlide(0);
      };

      modes.forEach((button) => {
        button.addEventListener("click", () => {
          _setMode(button.dataset.mode);
        });
      });

      if (previousButton) {
        previousButton.addEventListener("click", () => {
          _renderSlide(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", () => {
          _renderSlide(activeIndex + 1);
        });
      }

      if (gallery) {
        gallery.addEventListener("keydown", (event) => {
          if (event.target.tagName === "VIDEO" || activeSlides.length < 2) {
            return;
          }

          if (event.key === "ArrowLeft") {
            event.preventDefault();
            _renderSlide(activeIndex - 1);
          }

          if (event.key === "ArrowRight") {
            event.preventDefault();
            _renderSlide(activeIndex + 1);
          }
        });
      }

      if (slides.length) {
        const hasPhotos = slides.some((slide) => {
          return slide.dataset.kind === "photo";
        });

        _setMode(hasPhotos ? "photo" : "intro");
      }

      /* ==================== 产品图片 / 视频切换 end ==================== */

      /* ==================== Connections & compatibility begin ==================== */

      const connectionsWrapper = this._q(
        ".et3ps__connections-wrapper",
        sectionEl
      );

      const connectionsTrigger = connectionsWrapper
        ? this._q('[name="et3ps__connections-trigger"]', connectionsWrapper)
        : null;

      const connectionsPanel = connectionsWrapper
        ? this._q('[name="et3ps__connections-panel"]', connectionsWrapper)
        : null;

      const connectionsClose = connectionsPanel
        ? this._q('[name="et3ps__connections-close"]', connectionsPanel)
        : null;

      // 由 wrapper 的 open 状态统一控制面板和按钮状态。
      const _setConnectionsOpen = (open) => {
        if (!connectionsWrapper || !connectionsPanel) return;

        connectionsWrapper.classList.toggle("open", open);

        if (connectionsTrigger) {
          connectionsTrigger.setAttribute(
            "aria-expanded",
            open ? "true" : "false"
          );

          const icon = this._q('[aria-hidden="true"]', connectionsTrigger);

          if (icon) {
            icon.textContent = open ? "×" : "+";
          }
        }

        if (connectionsClose) {
          connectionsClose.setAttribute(
            "aria-expanded",
            open ? "true" : "false"
          );
        }
      };

      const _toggleConnections = () => {
        if (!connectionsWrapper || !connectionsPanel) return;

        const open = !connectionsWrapper.classList.contains("open");

        // 收起时，避免焦点留在即将隐藏的面板内部。
        if (
          !open &&
          connectionsTrigger &&
          connectionsPanel.contains(document.activeElement)
        ) {
          connectionsTrigger.focus();
        }

        _setConnectionsOpen(open);
      };

      if (connectionsWrapper && connectionsTrigger && connectionsPanel) {
        connectionsTrigger.addEventListener("click", _toggleConnections);

        if (connectionsClose) {
          connectionsClose.addEventListener("click", _toggleConnections);
        }

        _setConnectionsOpen(connectionsWrapper.classList.contains("open"));
      }

      /* ==================== Connections & compatibility end ==================== */

      /* ==================== Compare options begin ==================== */

      const compareToggle = this._q(
        '[name="et3ps__compare-toggle"]',
        sectionEl
      );

      const compareDialog = this._q(
        '[name="et3ps__dialog"][data-dialog="compare"]',
        sectionEl
      );

      // 切换关键功能 / 全部功能，并回到对比内容顶部。
      const _toggleCompareFeatures = () => {
        if (!compareToggle || !compareDialog) return;

        const expanded = compareToggle.getAttribute("aria-expanded") !== "true";

        this._qa("[data-extra]", compareDialog).forEach((row) => {
          row.hidden = !expanded;
        });

        compareToggle.setAttribute(
          "aria-expanded",
          expanded ? "true" : "false"
        );

        compareToggle.textContent = expanded
          ? compareToggle.dataset.collapseLabel
          : compareToggle.dataset.expandLabel;

        const scrollArea = this._q(
          '[name="et3ps__compare-scroll"]',
          compareDialog
        );

        if (scrollArea) {
          scrollArea.scrollTop = 0;
        }
      };

      if (compareToggle && compareDialog) {
        compareToggle.addEventListener("click", _toggleCompareFeatures);
      }

      /* ==================== Compare options end ==================== */

      /* ==================== 公共弹窗开关与事件 begin ==================== */

      const dialogs = this._qa(
        '[name="et3ps__dialog"][data-dialog="compare"]',
        sectionEl
      );

      const _closeDialog = (dialog) => {
        if (!dialog || !dialog.open) return;

        dialog.close();
      };

      const _openDialog = (key, opener) => {
        const dialog = dialogs.filter((item) => {
          return item.dataset.dialog === key;
        })[0];

        if (!dialog || typeof dialog.showModal !== "function") {
          return;
        }

        if (dialog.open) return;

        if (activeDialog && activeDialog !== dialog) {
          activeDialog.close();
        }

        try {
          dialog.showModal();
        } catch (error) {
          console.warn("[ExtendSectionT3Product] Unable to open dialog", error);

          return;
        }

        activeDialog = dialog;
        dialogOpener = opener;
        _lockScroll();
      };

      this._qa(
        '[name="et3ps__dialog-open"][data-dialog="compare"]',
        sectionEl
      ).forEach((button) => {
        button.addEventListener("click", () => {
          _openDialog("compare", button);
        });
      });

      dialogs.forEach((dialog) => {
        this._qa('[name="et3ps__dialog-close"]', dialog).forEach((button) => {
          button.addEventListener("click", () => {
            _closeDialog(dialog);
          });
        });

        // 点击面板外部时关闭。
        dialog.addEventListener("click", (event) => {
          if (event.target !== dialog) return;

          const rect = dialog.getBoundingClientRect();

          const outside =
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom;

          if (outside) {
            _closeDialog(dialog);
          }
        });

        // 关闭后恢复滚动和入口焦点，Escape 使用原生关闭行为。
        dialog.addEventListener("close", () => {
          if (activeDialog !== dialog) return;

          activeDialog = null;
          _unlockScroll();

          if (!destroyed && dialogOpener && dialogOpener.isConnected) {
            dialogOpener.focus();
          }

          dialogOpener = null;
        });
      });

      /* ==================== 公共弹窗开关与事件 end ==================== */

      /* ==================== 配件、总价与加购 begin ==================== */

      const form = this._q('[name="et3ps__form"]', sectionEl);
      const accessories = this._qa('[name="et3ps__accessory"]', sectionEl);
      const total = this._q('[name="et3ps__total"]', sectionEl);
      const addButton = this._q('[name="et3ps__add"]', sectionEl);
      const errorElement = this._q('[name="et3ps__error"]', sectionEl);

      let busy = false;
      let requestController = null;

      const addLabel = addButton ? addButton.textContent.trim() : "";

      const _isAccessorySelected = (accessory) => {
        return (
          accessory.getAttribute("aria-checked") === "true" &&
          accessory.getAttribute("aria-disabled") !== "true"
        );
      };

      // 同步配件状态、卡片选中样式和勾号。
      const _setAccessorySelected = (accessory, selected) => {
        const available = accessory.getAttribute("aria-disabled") !== "true";

        const checked = available && selected;
        const card = accessory.closest(".et3ps__card");
        const icon = this._q(".et3ps__accessory-check-icon", accessory);

        accessory.setAttribute("aria-checked", checked ? "true" : "false");

        if (card) {
          card.classList.toggle("et3ps__card--selected", checked);
        }

        if (icon) {
          icon.textContent = checked ? "✓" : "";
        }
      };

      const _formatMoney = (cents) => {
        const amount = cents / 100;
        const locale = document.documentElement.lang || "en";

        try {
          return new Intl.NumberFormat(locale, {
            style: "decimal",
            minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
            maximumFractionDigits: 2,
          }).format(amount);
        } catch (error) {
          return amount.toFixed(cents % 100 === 0 ? 0 : 2);
        }
      };

      // 主产品金额加上已选中且可购买的配件金额。
      const _updateTotal = () => {
        if (!form) return;

        let cents = Number(form.dataset.price || 0);

        accessories.forEach((accessory) => {
          if (_isAccessorySelected(accessory)) {
            cents += Number(accessory.dataset.price || 0);
          }
        });

        if (total) {
          total.textContent = _formatMoney(cents);
        }

        if (addButton) {
          addButton.disabled = busy || form.dataset.purchasable !== "true";
        }
      };

      const _setBusy = (value) => {
        busy = value;

        if (form) {
          form.setAttribute("aria-busy", value ? "true" : "false");
        }

        if (addButton) {
          addButton.textContent = value ? form.dataset.loadingLabel : addLabel;
        }

        _updateTotal();
      };

      const _showError = (message) => {
        if (!errorElement || !form) return;

        errorElement.textContent = message || form.dataset.errorLabel;

        errorElement.hidden = false;
      };

      // 汇总主产品和配件，重复变体合并数量。
      const _getItems = () => {
        const items = [];
        const itemMap = {};
        const variantInput = this._q('input[name="id"]', form);

        const _addItem = (variantId) => {
          const id = String(variantId || "");

          if (!/^\d+$/.test(id)) return;

          if (itemMap[id]) {
            itemMap[id].quantity += 1;
            return;
          }

          const item = {
            id: id,
            quantity: 1,
          };

          itemMap[id] = item;
          items.push(item);
        };

        if (variantInput) {
          _addItem(variantInput.value);
        }

        accessories.forEach((accessory) => {
          if (_isAccessorySelected(accessory)) {
            _addItem(accessory.dataset.variantId);
          }
        });

        return items;
      };

      const _submit = (event) => {
        event.preventDefault();

        if (busy || destroyed || !form || form.dataset.purchasable !== "true") {
          return;
        }

        const items = _getItems();

        if (!items.length) {
          _showError(form.dataset.errorLabel);
          return;
        }

        if (errorElement) {
          errorElement.textContent = "";
          errorElement.hidden = true;
        }

        _setBusy(true);

        requestController =
          typeof AbortController === "function" ? new AbortController() : null;

        /* cart-sections begin */
        const sectionsToBundle = [];

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:bundled-sections", {
            bubbles: true,
            detail: {
              sections: sectionsToBundle,
            },
          })
        );
        /* cart-sections end */

        const options = {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: items,
            sections: sectionsToBundle,
            sections_url: window.location.pathname,
          }),
        };

        if (requestController) {
          options.signal = requestController.signal;
        }

        // 区分加购失败与加购成功后的界面同步失败，避免重复加购。
        let added = false;

        fetch(wrapper.dataset.cartAdd, options)
          .then((response) => {
            return response.json().then((data) => {
              if (!response.ok || data.status) {
                const message =
                  typeof data.description === "string"
                    ? data.description
                    : typeof data.message === "string"
                      ? data.message
                      : form.dataset.errorLabel;

                throw new Error(message);
              }

              return data;
            });
          })
          .then(async (parsedState) => {
            added = true;

            if (destroyed || !sectionEl.isConnected) return;

            /* cart-sync begin */
            const cartOptions = {
              ...theme.utils.fetchConfig("json", "GET"),
            };

            if (requestController) {
              cartOptions.signal = requestController.signal;
            }

            const cartResponse = await fetch(
              theme.routes.cart_url,
              cartOptions
            );

            if (!cartResponse.ok) {
              throw new Error("Unable to refresh cart.");
            }

            const cartJson = await cartResponse.json();

            if (destroyed || !sectionEl.isConnected) return;

            const sections = parsedState.sections;

            // 框架的 CartItems 需要读取这些 section HTML。
            if (
              !sections ||
              sectionsToBundle.some((sectionId) => {
                return typeof sections[sectionId] !== "string";
              })
            ) {
              throw new Error("Unable to refresh cart sections.");
            }

            cartJson.sections = sections;

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: "t3-product-showcase",
              productVariantId: items[0].id,
              cart: cartJson,
            });
            /* cart-sync end */

            _setBusy(false);

            /* Open cart drawer begin */
            const cartDrawer = document.getElementById("CartDrawer");

            if (cartDrawer && typeof cartDrawer.show === "function") {
              cartDrawer.show(addButton);
            } else {
              window.location.assign(wrapper.dataset.cartUrl);
            }
            /* Open cart drawer end */
          })
          .catch((error) => {
            if (destroyed || error.name === "AbortError") return;

            _setBusy(false);

            // 商品已经加入时，不提示再次加购，转到购物车查看。
            if (added) {
              console.warn("[ExtendSectionT3Product] Cart sync failed:", error);

              window.location.assign(wrapper.dataset.cartUrl);
              return;
            }

            _showError(error.message || form.dataset.errorLabel);
          });
      };

      // 点击整张可选卡片切换，键盘操作由选择标记承接。
      accessories.forEach((accessory) => {
        const card = accessory.closest(".et3ps__card");

        _setAccessorySelected(
          accessory,
          accessory.getAttribute("aria-checked") === "true"
        );

        const _toggleAccessory = () => {
          if (
            busy ||
            destroyed ||
            accessory.getAttribute("aria-disabled") === "true"
          ) {
            return;
          }

          _setAccessorySelected(accessory, !_isAccessorySelected(accessory));

          _updateTotal();
        };

        if (card) {
          card.addEventListener("click", (event) => {
            // 卡片内的链接仍按原链接行为处理。
            if (event.target.closest("a")) return;

            _toggleAccessory();
          });
        }

        accessory.addEventListener("keydown", (event) => {
          if (event.key !== " " && event.key !== "Enter") return;

          event.preventDefault();
          _toggleAccessory();
        });
      });

      if (form) {
        form.addEventListener("submit", _submit);
        _updateTotal();
      }

      /* ==================== 配件、总价与加购 end ==================== */

      /* ==================== Section 卸载清理 begin ==================== */

      const _cleanup = (event) => {
        const target = event.target;

        if (
          target !== sectionEl &&
          !(target && target.contains && target.contains(sectionEl))
        ) {
          return;
        }

        destroyed = true;

        // 清理 Connections 两个按钮的事件。
        if (connectionsTrigger) {
          connectionsTrigger.removeEventListener("click", _toggleConnections);
        }

        if (connectionsClose) {
          connectionsClose.removeEventListener("click", _toggleConnections);
        }

        if (requestController) {
          requestController.abort();
        }

        _pauseVideos();

        dialogs.forEach((dialog) => {
          if (dialog.open) {
            dialog.close();
          }
        });

        _unlockScroll();

        document.removeEventListener("shopify:section:unload", _cleanup);
      };

      document.addEventListener("shopify:section:unload", _cleanup);

      /* ==================== Section 卸载清理 end ==================== */
    };

    /* ==================== 初次绑定与编辑器重载 begin ==================== */

    this._registerSectionLoad({
      key: "t3ProductShowcase",
      className: "extend-t3-product-showcase",
      onLoad: (sectionEl) => {
        _bindSection(sectionEl);
      },
    });

    this._qa(".extend-t3-product-showcase").forEach((sectionEl) => {
      _bindSection(sectionEl);
    });

    /* ==================== 初次绑定与编辑器重载 end ==================== */
  }
}
